<template>
  <div id="app">
    <navigation/>
    <router-view/>
  </div>
</template>

<script>
import navigation from "./components/navigation";

export default {
  name: 'app',
  components: {
    navigation
  },
  watch: {
    '$route':{
      handler: (to) => {

        if(to.meta.title && to.meta.title != 'Annamaria Koshy')
          document.title = to.meta.title + " - Annamaria Koshy"
        else
          document.title = 'Annamaria Koshy'
      },
      immediate: true
    }
  },
}
</script>

<style>
@import './assets/styles/styles.css';
@font-face{
  font-family:'lemonmilk';
  src:url('./assets/fonts/LemonMilk.otf');
}

#app {
  display:flex;
  height:100vh;

}
</style>
